import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withParams from './withParams'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

const withEditPickupPersonForm = options => {
  const { redirect } = options

  const withEditPickupPersonFormResults = withFormResults({
    mutation: 'updatePickupPerson',
    field: 'pickupPerson',
    successMessage: 'Pick-up person updated',
    redirect
  })

  return compose(
    withErrorBoundary,
    withParams,
    withRedux,
    withQueryResults,
    withQuery,
    withEditPickupPersonFormResults,
    withMutation,
    withEventHandlers
  )
}

// in account manager, redirect to account overview
export default withEditPickupPersonForm({
  redirect: '/'
})(UI)

// export HOC for registration
export { withEditPickupPersonForm }
